import { render } from "./ProcessPaiement.vue?vue&type=template&id=066c5a9f&scoped=true&ts=true"
import script from "./ProcessPaiement.vue?vue&type=script&lang=ts"
export * from "./ProcessPaiement.vue?vue&type=script&lang=ts"

import "./ProcessPaiement.vue?vue&type=style&index=0&id=066c5a9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066c5a9f"]])

export default __exports__